import React, {Component} from 'react'

import MaterialIcon, {colorPalette} from 'material-icons-react';
import WidgetListItem from "../../components/Widgets/WidgetListItem";
import {Row, Col} from "react-bootstrap";
import scrollToComponent from 'react-scroll-to-component';
import TreeMapDelayWidget from "../../components/Widgets/TreeMapDelayWidget";
import WidgetHelper from "../../components/Helpers/WidgetHelper";
import Widget3 from "../../components/Widgets/Widget3";
import Widget5 from "../../components/Widgets/Widget5";
import Widget1 from "../../components/Widgets/Widget1";
import Widget2 from "../../components/Widgets/Widget2";


export default class WidgetsView extends Component {

    els = [];
    widgetHelper;
    constructor(props){
        super(props);
        this.els = [
            { id:1, name: "Detalle de rango", component: <Widget1 name="Detalle de rango" id={1} onSelectionChange={(b, id) => this.onSelectionChange(b, id)}/> },
            { id:2, name: "Actividad de equipo", component: <Widget2 name="Actividad de equipo" id={2} onSelectionChange={(b, id) => this.onSelectionChange(b, id)}/> },
            { id:3, name: "Detalles de afiliados", component: <Widget3 name="Detalles de afiliados" id={3} onSelectionChange={(b, id) => this.onSelectionChange(b, id)}/> },
            { id:4, name: "Mora", component: <TreeMapDelayWidget name="Mora" id={4} onSelectionChange={(b, id) => this.onSelectionChange(b, id)}/> },
            { id:5, name: "Detalle de cuotas por pagar", component: <Widget5 name="Detalle de cuotas por pagar" id={5} onSelectionChange={(b, id) => this.onSelectionChange(b, id)}/> },
        ];

        this.widgetHelper = new WidgetHelper();
    }

    componentWillMount() {
        this.setState({selectedOption: 1});
        this.topRef = React.createRef();
    }

    onWidgetSelected = (widget) => {
        this.setState({ selectedOption: widget.id });
        scrollToComponent(this.topRef, { offset: 0, align: 'top', duration: 500});
    };

    onSelectionChange = (b, id) => {
        if (b){
            this.widgetHelper.addWidgetById(id);
        } else {
            this.widgetHelper.removeWidgetById(id);
        }
    };

    render() {
        return (
            <div ref={elem => (this.topRef = elem)} className="fade-show">
                <Row>
                    <Col md={12}>
                        <h1 className="header">Reportes</h1>
                    </Col>
                </Row>
                {
                    this.els.find((e) => e.id === this.state.selectedOption).component
                }
                <Row>
                    <Col md={12}>
                        <h5 className="outlined">Tus reportes</h5>
                    </Col>
                </Row>

                <Row>
                    <Col md={12}>
                        <blockquote>Seleccione un reporte en la lista!</blockquote>
                    </Col>
                </Row>

                <Row className="card-widget-container-padding">
                    {
                        this.els.map((e, i) => {
                            return (
                                <WidgetListItem key={i} widget={e} position={i}
                                                checked={this.state.selectedOption === e.id}
                                                onItemChecked={(item) => this.onWidgetSelected(item)}/>
                            )
                        })
                    }
                </Row>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/views/Widgets/WidgetsView.jsx